<template>
  <div class="form-content">
    <input type="text" :name="`input_text_${name}`" required autocomplete="off">
    <label class="label-name" :for="`input_text_${name}`">
      <span class="content-name">{{placeholder}}</span>
    </label>
  </div>
</template>

<script>
  export default {
    name: 'TextInput',
    props: {
      name: String,
      placeholder: String,
    }
  }
</script>

<style scoped>

</style>
